export default {"src":"/_next/static/media/ai-based-targeting.fca8d127.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};